import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1" }, " Are you sure you want to delete this search? ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Delete Search",
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Delete",
        color: "negative",
        task: _ctx.task,
        onClick: _ctx.remove
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 512))
}